import { route } from '@aurelia/router';
import { Create } from './create';
import { EventSummary } from './event-summary';
import { EditEvent } from './edit-event';
import { EditSerie } from './edit-serie';
import { EditTeams } from './edit-teams';
import { EditSchedule } from './schedule/edit-schedule';
import { CustomizeSchedule } from './customize-schedule';
import { ReviewSchedule } from './review-schedule';
import { ManageVenues } from './venue/manage-venues';
import { ShareEvent } from './share-event';

@route({
  routes: [
    { id: 'create', path: ['', 'create'], component: Create, title: 'create', data: { requiresEditAccess: false } },
    { id: 'event-summary', path: ['event-summary/:eventId'], component: EventSummary, title: 'event-summary', data: { requiresEditAccess: false } },
    { id: 'edit-event', path: ['edit-event/:eventId'], component: EditEvent, title: 'edit-event', data: { requiresEditAccess: true } },
    { id: 'edit-serie', path: ['edit-serie/:eventId', 'edit-serie/:eventId/:scheduleId'], component: EditSerie, title: 'edit-serie', data: { requiresEditAccess: true } },
    { id: 'edit-teams', path: ['edit-teams', 'edit-teams/:eventId', 'edit-teams/:eventId/:groupId'], component: EditTeams, title: 'edit-teams', data: { requiresEditAccess: true } },
    { id: 'edit-schedule', path: 'edit-schedule', component: EditSchedule, title: 'edit-schedule', data: { requiresEditAccess: true } },
    { id: 'customize-schedule', path: 'customize-schedule', component: CustomizeSchedule, title: 'customize-schedule', data: { requiresEditAccess: true } },
    { id: 'review-schedule', path: 'review-schedule', component: ReviewSchedule, title: 'review-schedule', data: { requiresEditAccess: true } },
    { id: 'manage-venues', path: ['manage-venues/:eventId'], component: ManageVenues, title: 'manage-venues', data: { requiresEditAccess: true } },
    { id: 'share-event', path: ['share-event/:eventId'], component: ShareEvent, title: 'share-event', data: { requiresEditAccess: true } },
  ],
})
export class CreateSection {
}
